/**
 * 画直线的笔刷
 * @param {*} fabric
 * @param {*} canvas
 * @returns
 */
export default function(fabric, canvas, options = {}) {
  return new fabric.DiagramBrush(canvas, {
    getObject(opt, pointer) {
      const { originX, originY } = opt
      // [起始x,起始y,结束x,结束y]
      return new fabric.Line([0, 0, 0, 0], {
        name: options.name,
        left: originX,
        top: originY,
        originX: 'left',
        originY: 'top',
        fill: '',
        stroke: 'red',
        strokeWidth: 3,
        ...(options.line || {})
      })
    },
    renderMove(opt, pointer) {
      const { originX, originY } = opt
      const { x, y } = pointer
      const line = opt.curObject
      line.set({
        x1: originX,
        y1: originY,
        x2: x,
        y2: y
      })
    }
  })
}